module.exports = __webpack_public_path__ + "static/media/Guillaume.8a4a95cd.jpg";